import { IsString, MaxLength, MinLength } from "class-validator";

export class LoginCredentialsDto {
    // Gleiche Regeln wie beim Anlegen in der Benutzerverwaltung (SaveUserDto), Länge der DB-Spalte
    @IsString()
    @MinLength(4)
    @MaxLength(255)
    username!: string

    @IsString()
    password!: string
}
